export const ac_articles = [
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/G6PAG5TXPJF4HB37LSQHNGPB4Y.jpeg?auth=5e461501cfa5932c2879c596b50415680c817aab713162dede70618b398e2c38",
        article_title: "Inaugural Zora Neale Hurston Summit celebrates Hurston’s ‘life, legacy, and work’",
        article_authors: "Emily Chen",
        article_link: "https://www.columbiaspectator.com/arts-and-culture/2025/02/10/inaugural-zora-neale-hurston-summit-celebrates-hurstons-life-legacy-and-work/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/5FZUL5BVWBEPVDTFUEACNZFOZU.jpg?auth=afed011bdcbd6467a72cefc11e8b34a5d919625f04ee7cce4188136a4e12bfd0",
        article_title: "Soul is in the food at Amy Ruth's",
        article_authors: "Rachel Shaw",
        article_link: "https://www.columbiaspectator.com/arts-and-culture/2025/02/11/soul-is-in-the-food-at-amy-ruths/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/VYASJWPUANEOHP5KFLEPXLBJLQ.jpeg?auth=6521bebff844e52857ec85600fe2adae2df8163a855a8669441b43ca7e89b9e0",
        article_title: "Cancer researcher to VMAs dancer: Esosa Oviasu, CC ’14, on his journey of balance",
        article_authors: "Joyce Zhang",
        article_link: "https://www.columbiaspectator.com/arts-and-culture/2025/02/04/cancer-researcher-to-vmas-dancer-esosa-oviasu-cc-14-on-his-journey-of-balance/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/DUUBCJMTKJFGXNA324JPOVPBSU.jpeg?auth=30a069c0af46fbb95877799376871bbd69f61b5fc423e6cb373607f443eea590",
        article_title: "Laura R. Gadson opens solo quilt art show, ‘Truth, Tales & Fabrications’",
        article_authors: "Taylor Graham",
        article_link: "https://www.columbiaspectator.com/arts-and-culture/2025/02/12/laura-r-gadson-opens-solo-quilt-art-show-truth-tales-fabrications/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/CNIUUOJWN5B7FJNXAWP67BTIP4.jpg?auth=5d42488c084ead9bb12e4f937cc198407ffd4da19a1014c93c186961ef735af4",
        article_title: "A taste of home: Massawa’s history and the people who wrote it",
        article_authors: "Joyce Zhang",
        article_link: "https://www.columbiaspectator.com/arts-and-culture/2025/02/12/a-taste-of-home-massawas-history-and-the-people-who-wrote-it/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/IMZCWVHD7RGL7KJVDNGTNL7UHM.jpeg?auth=762fdf48d3246b05ae36623d5c11b4b656decfb22e549db1ebb34b8e25e4fbcc",
        article_title: "Tracing the New Amsterdam Musical Association’s past, present, and future as pillar of Harlem’s creative community",
        article_authors: "Ariana Eftimiu, Madison Rosenfield",
        article_link: "https://www.columbiaspectator.com/arts-and-culture/2025/02/12/tracing-the-new-amsterdam-musical-associations-past-present-and-future-as-a-pillar-of-harlems-creative-community/"
    }
];